import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LocalizationService } from '../../../localization/localization.service';
import { Locales } from '../../../localization/locales';

@Component({
  selector: 'mtg-agreement',
  templateUrl: './agreement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgreementComponent {
  locale = this.localizationService.getLocale();
  locales = Locales;

  constructor(
    private localizationService: LocalizationService,
  ) {
  }
}
